import { Injectable } from '@angular/core';
import { config } from '../../config/config';
import { AppModeService } from '../common/services/app.mode.service';

@Injectable()
export class ConfigService {
    private static _config = config;

    public static get config() {
        return ConfigService._config;
    }

    public load(http): Promise<any> {
        if (!AppModeService.isDevelopmentMode) {
            // return http.get(config.assetImageServeUrl + 'api/config')
            return http.get('https://stagingv2.imgoingcalendar.com/api/config')
                .map(res => {
                    if (!!res.json) {
                        return res.json();
                    }

                    return res;
                })
                .do(config => {
                    console.log(config);
                    ConfigService._config = config;
                })
                .toPromise();
        }

        return Promise.resolve(ConfigService._config);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/services/config.service.ts